{
  "title": "Profile",
  "screen": {
    "you": "You",
    "errorTitle": "Something went wrong",
    "errorBody": "The profile screen hit an error. Try again to reload it.",
    "retryA11y": "Retry loading profile",
    "accountDeletedTitle": "Account deleted",
    "accountDeletedBody": "Your account and data have been permanently removed. We’ve emailed you a confirmation.",
    "deleteFailedTitle": "Delete account",
    "deleteFailedBody": "Something went wrong deleting your account. Please try again.",
    "deleting": "Deleting…",
    "deactivating": "Deactivating…",
    "reactivating": "Reactivating…",
    "deactivatedTitle": "Account deactivated",
    "deactivatedBody": "You're hidden from everyone. Nothing has been deleted — reactivate from your profile whenever you want.",
    "reactivatedTitle": "Welcome back",
    "reactivatedBody": "Your account is social again. Become visible to start seeing people nearby.",
    "deactivateFailedTitle": "Account",
    "deactivateFailedBody": "Something went wrong changing your account. Please try again.",
    "notificationsBlockedTitle": "Notifications blocked",
    "notificationsBlockedBody": "Enable notifications in your device settings to receive push alerts.",
    "notificationsFailedTitle": "Unable to update notifications"
  },
  "sections": {
    "visibleProfile": "Visible profile",
    "visibleProfileBody": "Give people a sense of who you are before they send a Cue.",
    "displayName": "Display name",
    "headline": "Headline",
    "ageBand": "Age band",
    "friendshipGoal": "What brings you here",
    "languages": "Languages",
    "privateProfile": "Private profile",
    "privateProfileBody": "Only you and people you mutually Reveal with can see private details.",
    "actualAge": "Actual age",
    "about": "About",
    "interests": "Interests",
    "gender": "Gender",
    "religion": "Religion",
    "politics": "Politics",
    "profile": "Profile",
    "account": "Account",
    "deactivate": "Deactivate account",
    "deactivateBody": "Go quiet without losing anything. You keep Practice, goals and reflections.",
    "deactivateHint": "Hides you from everyone; nothing is deleted",
    "reactivate": "Reactivate",
    "reactivateBody": "You're deactivated. Turn the social side of Opncue back on.",
    "reactivateHint": "Makes your account social again",
    "progressA11y": "View your progress",
    "progress": "Progress",
    "progressBody": "Track your week, reflect, and celebrate your growth.",
    "stayVisibleA11y": "Stay visible settings",
    "stayVisible": "Stay visible",
    "stayVisibleBody": "Receive Cues when locked or using other apps.",
    "editA11y": "Edit profile",
    "edit": "Edit profile",
    "editBody": "Update your name, about, and personal details.",
    "notificationsA11y": "Customize notifications",
    "notifications": "Notifications",
    "helpA11y": "Help and support",
    "help": "Help & Support",
    "helpBody": "Get help, stay safe, report a problem, or send feedback.",
    "signOutA11y": "Sign out",
    "signOut": "Sign out",
    "signOutBody": "You can come back anytime.",
    "deleteA11y": "Delete account",
    "deleteHint": "Permanently deletes your account and data",
    "delete": "Delete account",
    "deleteBody": "Permanently delete your account, profile, and associated data.",
    "appearance": "Appearance",
    "plusDev": "Opncue Plus (dev)",
    "plusDevBody": "Test Plus features without upgrading. Development builds only.",
    "protection": "How Opncue protects you",
    "protectionBody": "Private, low-pressure conversations.",
    "tagline": "Real conversations start nearby.",
    "managePlanA11y": "Manage plan",
    "upgradePlanA11y": "Upgrade plan",
    "manageSubscription": "Manage subscription",
    "plusGrantActive": "Plus access active",
    "plusGrantActiveBody": "Your Plus access is active.",
    "plusGrantActiveUntil": "Your Plus access runs until {{date}}.",
    "upgradePlan": "Upgrade plan",
    "manageSubscriptionBody": "View your plan, billing date, and payment method, or cancel.",
    "upgradePlanBody": "Get more cues, more starts, and more room to connect.",
    "alertsBody": "Manage alerts from Opncue",
    "mutedBody": "All push alerts are muted."
  },
  "appearance": {
    "device": "Device",
    "light": "Light",
    "dark": "Dark",
    "current": "Current",
    "themeA11y": "{{theme}} theme"
  },
  "principles": {
    "privateTitle": "Private by default",
    "privateBody": "You only Reveal more when you feel comfortable.",
    "momentTitle": "Made for the moment",
    "momentBody": "No anxiously waiting to meet.",
    "pressureTitle": "No popularity pressure",
    "pressureBody": "No public profiles, follower counts, or likes.",
    "blockTitle": "Block and report",
    "blockBody": "Block someone if you don’t want them to ever send you a Cue again."
  },
  "plan": {
    "closeA11y": "Close plan details",
    "plus": "Opncue Plus",
    "perYear": "/year",
    "body": "Meet a few people nearby. Give each interaction attention. Leave kindly if the vibe is not there. Make room for someone else.",
    "free": "Free",
    "plusTier": "Plus",
    "freePlanA11y": "Free plan",
    "plusPlanA11y": "Plus plan",
    "cancelPlan": "Cancel plan",
    "cancelPlanButton": "Cancel Plan",
    "selectPlan": "Select a plan"
  },
  "notifications": {
    "closeA11y": "Close notification settings",
    "muteAll": "Mute all notifications",
    "muteAllBody": "Pause every push alert from Opncue.",
    "newPeople": "New people",
    "newPeopleBody": "Someone new becomes visible in your current space.",
    "cues": "Cues",
    "cuesBody": "New Cue requests and accepted Cues.",
    "messages": "Messages",
    "messagesBody": "New replies in accepted conversations.",
    "goalReminders": "Goal reminders",
    "goalRemindersBody": "A nudge two days before a small goal is due.",
    "systemOff": "Notifications are turned off for Opncue in your device settings. Tap to turn them back on.",
    "nudgeBody": "Notifications are off — new activity is waiting. Tap to turn them on.",
    "nudgeDismissA11y": "Dismiss this reminder"
  },
  "confirm": {
    "closeA11y": "Close confirmation",
    "signOutTitle": "Sign out of Opncue?",
    "signOutBody": "Your profile and conversations will remain saved. You can come back anytime.",
    "deactivateTitle": "Deactivate your account?",
    "deactivateBody": "Nobody will see your profile, and you won't be able to send cues or messages or join Small Groups. Nothing is deleted, and you can reactivate whenever you like. Your subscription keeps running.",
    "deactivateAction": "Deactivate",
    "reactivateTitle": "Reactivate your account?",
    "reactivateBody": "Your profile becomes visible again and cues, messages and Small Groups come back. Everything is exactly where you left it.",
    "deleteTitle": "Delete your account?",
    "deleteBody": "This will permanently remove your profile, Cues, conversations, and account information. This action cannot be undone.",
    "deleteAction": "Delete",
    "deletePermanent": "This is permanent. We’ll delete your profile, Cues, conversations, goals, reflections, and local session."
  },
  "edit": {
    "optional": "Optional",
    "all": "All",
    "closeA11y": "Close edit profile",
    "title": "Edit profile",
    "body": "Help people understand what you have in common.",
    "visibleSection": "Visible profile",
    "visibleSectionBody": "Help people nearby understand who you are when you’re visible.",
    "displayName": "Display name",
    "displayNamePlaceholder": "What should people call you?",
    "randomName": "Random name",
    "ageBand": "Age band",
    "headline": "Headline",
    "headlinePlaceholder": "A quick line about your vibe",
    "bio": "About",
    "bioHelp": "A short introduction, your ideal hangout, or something people can ask you about.",
    "languages": "Languages",
    "languagePlaceholder": "Add your language",
    "addLanguageA11y": "Add custom language",
    "friendshipGoal": "What brings you here?",
    "friendshipGoalBody": "Choose one friendship goal. You can change this any time.",
    "goalPlaceholder": "Tell people what you are looking for",
    "addGoalA11y": "Add custom reason",
    "interests": "Interests",
    "interestPlaceholder": "Add another interest",
    "addInterestA11y": "Add custom interest",
    "gender": "Gender",
    "genderLocked": "Contact support to change your gender.",
    "ageRange": "Age range",
    "ageRangeBody": "Choose what age range can see you.",
    "genderPreference": "Who can discover you",
    "genderPreferenceBody": "Choose which genders can see you in Nearby.",
    "nearbyRange": "Nearby range",
    "nearbyRangeBody": "How close someone needs to be for you to see each other.",
    "religion": "Religion",
    "politics": "Politics",
    "cancelA11y": "Cancel editing profile",
    "saveA11y": "Save profile",
    "saveFailedTitle": "Could not save profile",
    "saveFailedBody": "Something went wrong. Please try again.",
    "interestLimitTitle": "Interest limit reached",
    "interestLimitBody": "Choose up to {{count}} interests.",
    "addItemTitle": "Add {{label}}",
    "typeItemFirst": "Type {{label}} first.",
    "alreadyAvailableTitle": "Already in the list",
    "alreadyAvailableBody": "{{value}} is already available as an option.",
    "alreadyAddedTitle": "Already added",
    "alreadyAddedBody": "{{value}} is already in your list.",
    "customLimitTitle": "Limit reached",
    "customLimitBody": "Add up to {{count}} custom {{label}} entries.",
    "addReasonTitle": "Add reason",
    "typeReasonFirst": "Type what you are looking for first.",
    "languageLimitTitle": "Language limit reached",
    "languageLimitBody": "Choose up to {{count}} languages.",
    "addLanguageTitle": "Add language",
    "typeLanguageFirst": "Type your language first.",
    "typeLanguageToAdd": "Type the language you want to add.",
    "languageAlreadyAdded": "{{value}} is already in your languages.",
    "interestLabel": "interest",
    "fieldValueA11y": "{{label}}: {{value}}",
    "closeOptionsA11y": "Close {{label}} options",
    "clear": "Clear",
    "notSet": "Not set",
    "selectedCount": "{{selected}} of {{limit}} selected",
    "interestHint": "Choose up to {{count}} things you enjoy.",
    "customSelected": "{{selected}} of {{limit}} custom",
    "saved": "Saved",
    "save": "Save",
    "saveChanges": "Save changes"
  },
  "interests": {
    "coffee": "Coffee",
    "food": "Food",
    "music": "Music",
    "movies": "Movies",
    "books": "Books",
    "gaming": "Gaming",
    "fitness": "Fitness",
    "running": "Running",
    "hiking": "Hiking",
    "travel": "Travel",
    "art": "Art",
    "photography": "Photography",
    "technology": "Technology",
    "startups": "Startups",
    "fashion": "Fashion",
    "cooking": "Cooking",
    "dancing": "Dancing",
    "sports": "Sports",
    "volunteering": "Volunteering",
    "languages": "Languages",
    "other": "Other"
  },
  "guest": {
    "unavailableTitle": "Profile unavailable",
    "unavailableBody": "This person may no longer be active in your space.",
    "unavailableLink": "Open this from your list — this link only works in the tab you opened it from.",
    "backA11y": "Go back",
    "kicker": "PROFILE",
    "publicProfile": "Public profile",
    "friendshipGoal": "What brings you here",
    "languages": "Languages",
    "revealed": "Shared after Reveal",
    "about": "About",
    "actualAge": "Actual age",
    "moreInterests": "More interests",
    "moreReasons": "More reasons",
    "religion": "Religion",
    "bothRevealed": "You both chose to share more.",
    "revealLocked": "These details stay blurred until you both share more.",
    "notShared": "Not shared",
    "notAnswered": "Not Answered",
    "blurred": "Blurred until mutual reveal"
  },
  "publicModal": {
    "closeA11y": "Close public profile",
    "bio": "Bio",
    "interests": "Interests",
    "friendshipGoal": "What brings you here",
    "languages": "Languages"
  },
  "report": {
    "reasons": {
      "harassment": "Harassment or bullying",
      "messages": "Inappropriate messages",
      "sexual": "Sexual content or behavior",
      "hate": "Hate speech or discrimination",
      "threats": "Threats or violence",
      "spam": "Spam or scam",
      "fake": "Fake profile or impersonation",
      "underage": "Underage user",
      "unsafe": "Unsafe in-person behavior",
      "other": "Other"
    },
    "chooseReasonTitle": "Choose a reason",
    "chooseReasonBody": "Let us know what happened so we can review it.",
    "submittedTitle": "Report submitted",
    "submittedBody": "Thanks for letting us know. Our team will review it.",
    "failedTitle": "Couldn’t submit",
    "failedBody": "Please try again in a moment.",
    "closeA11y": "Close report",
    "title": "Report this person",
    "body": "Tell us what happened. They won’t be notified that you reported them.",
    "detailsPlaceholder": "Add any details that help us understand…",
    "screenshotTitle": "Optional",
    "screenshotBody": "Screenshot uploads are coming soon. Describe what happened above and our team can follow up.",
    "uploadScreenshot": "Upload screenshot (optional)",
    "block": "Block this person",
    "endConversation": "End this conversation",
    "hide": "Hide me from this person",
    "reasonLabel": "Reason for report",
    "whatHappened": "What happened?",
    "addEvidence": "Add evidence",
    "nextAction": "What should happen now?",
    "submitting": "Submitting…",
    "submit": "Submit report"
  },
  "badges": {
    "openToChat": "Open to chat",
    "workingQuietly": "Working quietly",
    "newHere": "New here",
    "away": "Away"
  },
  "a11y": {
    "chooseDateOfBirth": "Choose date of birth",
    "selectDateOfBirth": "Select date of birth",
    "confirm": "Confirm",
    "dismiss": "Dismiss",
    "notAdded": "Not added",
    "identityVerified": "Identity verified"
  },
  "generatedName": {
    "nouns": {
      "10": "Delta",
      "11": "Echo",
      "12": "Ember",
      "13": "Garden",
      "14": "Grove",
      "15": "Harbor",
      "16": "Haven",
      "17": "Heron",
      "18": "Lantern",
      "19": "Maple",
      "20": "Meadow",
      "21": "Muse",
      "22": "Nova",
      "23": "Orbit",
      "24": "Pilot",
      "25": "Ridge",
      "26": "River",
      "27": "Scout",
      "28": "Summit",
      "29": "Willow",
      "30": "Zephyr",
      "01": "Anchor",
      "02": "Atlas",
      "03": "Aurora",
      "04": "Beacon",
      "05": "Bloom",
      "06": "Bridge",
      "07": "Canyon",
      "08": "Cedar",
      "09": "Comet"
    }
  },
  "validation": {
    "required": "Enter a display name.",
    "trim": "No spaces at the start or end.",
    "singleSpace": "Use one space between words.",
    "maxOneSpace": "Use one space max.",
    "maxTwoWords": "Use two words max.",
    "minLength": "Use at least {{min}} characters.",
    "lengthRange": "Use {{min}}–{{max}} characters.",
    "noHandle": "No @handles or emails in your name.",
    "noLink": "No links in your name.",
    "noPhone": "No phone numbers in your name.",
    "allowed": "Only letters, numbers, spaces, apostrophes, hyphens, and periods.",
    "chooseReason": "Choose a reason",
    "chooseInterests": "Choose interests",
    "closePopup": "Close popup"
  },
  "avatar": {
    "title": "Create your avatar",
    "subtitle": "Choose a look that helps people recognize you. You can update it anytime.",
    "save": "Save",
    "saveA11y": "Save avatar",
    "close": "Close",
    "closeA11y": "Close avatar editor",
    "cancel": "Cancel",
    "discardChanges": "Discard changes?",
    "randomize": "Randomize",
    "reset": "Reset",
    "undo": "Undo avatar change",
    "redo": "Redo avatar change",
    "saved": "Avatar updated",
    "updated": "Avatar updated",
    "error": "Couldn't save your avatar. Please try again.",
    "editA11y": "Edit your avatar",
    "editHint": "Opens the avatar editor",
    "ownLabel": "Your avatar",
    "otherLabel": "{{name}}'s avatar",
    "previewA11y": "Your avatar preview",
    "selected": "Selected",
    "deselect": "None",
    "categories": {
      "skin": "Skin",
      "hair": "Hair",
      "eyes": "Eyes",
      "brows": "Brows",
      "nose": "Nose",
      "lips": "Lips",
      "glasses": "Glasses",
      "accessories": "Accessories",
      "clothing": "Clothing",
      "extras": "Extras"
    },
    "sections": {
      "skinTone": "Skin tone",
      "faceShape": "Face shape",
      "eyeStyle": "Eye shape",
      "eyeColor": "Eye color",
      "browStyle": "Brow style",
      "noseStyle": "Nose",
      "hairStyle": "Hair style",
      "hairColor": "Hair color",
      "facialHair": "Facial hair",
      "glasses": "Glasses",
      "headCovering": "Head covering",
      "expression": "Expression",
      "topStyle": "Top style",
      "topColor": "Top color",
      "accessory": "Accessory",
      "vibeIcon": "Vibe icon",
      "profilePin": "Profile pin"
    },
    "options": {
      "skinTone": {
        "neutral_yellow": "Neutral yellow",
        "tone_1": "Tone 1",
        "tone_2": "Tone 2",
        "tone_3": "Tone 3",
        "tone_4": "Tone 4",
        "tone_5": "Tone 5",
        "tone_6": "Tone 6",
        "tone_7": "Tone 7",
        "tone_8": "Tone 8"
      },
      "faceShape": {
        "oval": "Oval",
        "round": "Round",
        "square": "Square",
        "rectangle": "Rectangle",
        "heart": "Heart",
        "diamond": "Diamond",
        "triangle": "Triangle"
      },
      "eyeStyle": {
        "round": "Round",
        "almond": "Almond",
        "wide": "Wide",
        "narrow": "Narrow",
        "upturned": "Upturned",
        "sleepy": "Sleepy"
      },
      "eyeColor": {
        "brown": "Brown",
        "dark_brown": "Dark brown",
        "amber": "Amber",
        "hazel": "Hazel",
        "green": "Green",
        "blue": "Blue",
        "gray": "Gray",
        "violet": "Violet"
      },
      "browStyle": {
        "soft": "Soft",
        "straight": "Straight",
        "arched": "Arched",
        "thick": "Thick",
        "thin": "Thin",
        "rounded": "Rounded"
      },
      "noseStyle": {
        "soft": "Soft",
        "round": "Round",
        "narrow": "Narrow",
        "wide": "Wide",
        "button": "Button"
      },
      "hairStyle": {
        "none": "No hair",
        "buzz_cut": "Buzz cut",
        "short_straight": "Short",
        "cropped": "Cropped",
        "short_curls": "Short curls",
        "medium_curls": "Medium curls",
        "wavy": "Wavy",
        "long": "Long",
        "bun": "Bun",
        "short_locs": "Short locs",
        "box_braids": "Box braids",
        "long_locs": "Long locs",
        "fade": "Fade",
        "side_part": "Side part"
      },
      "hairColor": {
        "jet_black": "Jet Black",
        "dark_espresso": "Dark Espresso",
        "chestnut_brown": "Chestnut Brown",
        "honey_blonde": "Honey Blonde",
        "deep_auburn": "Deep Auburn",
        "classic_ginger": "Classic Ginger",
        "silver_gray": "Silver Gray",
        "off_white": "Off-White",
        "electric_blue": "Electric Blue",
        "hot_pink": "Hot Pink",
        "vibrant_violet": "Vibrant Violet",
        "sandy_blonde": "Sandy Blonde",
        "copper_red": "Copper Red",
        "salt_pepper": "Salt & Pepper",
        "mint_green": "Mint Green",
        "soft_lavender": "Soft Lavender",
        "rose_gold": "Rose Gold",
        "teal_blue": "Teal Blue"
      },
      "facialHair": {
        "none": "None",
        "stubble": "Stubble",
        "mustache": "Mustache",
        "beard_short": "Short beard",
        "beard_full": "Full beard",
        "goatee": "Goatee"
      },
      "glasses": {
        "none": "None",
        "round": "Round",
        "square": "Square",
        "thin": "Thin",
        "bold": "Bold"
      },
      "headCovering": {
        "none": "None",
        "beanie": "Beanie",
        "cap": "Cap",
        "headscarf": "Headscarf",
        "turban": "Turban",
        "wrap": "Wrap"
      },
      "expression": {
        "soft_smile": "Soft smile",
        "smile": "Smile",
        "calm": "Calm",
        "cheerful": "Cheerful",
        "neutral": "Neutral"
      },
      "topStyle": {
        "tee": "Tee",
        "hoodie": "Hoodie",
        "sweater": "Sweater",
        "jacket": "Jacket",
        "collared": "Collared"
      },
      "topColor": {
        "blue": "Blue",
        "navy": "Navy",
        "sky": "Sky",
        "teal": "Teal",
        "green": "Green",
        "amber": "Amber",
        "coral": "Coral",
        "pink": "Pink",
        "purple": "Purple",
        "slate": "Slate"
      },
      "accessory": {
        "none": "None",
        "headphones": "Headphones",
        "earrings": "Earrings",
        "pin": "Pin",
        "scarf": "Scarf"
      },
      "vibeIcon": {
        "none": "None",
        "coffee": "Coffee",
        "book": "Book",
        "music": "Music",
        "walk": "Walk",
        "game": "Game",
        "art": "Art",
        "sport": "Sport",
        "food": "Food",
        "volunteer": "Volunteer",
        "study": "Study"
      },
      "profilePin": {
        "none": "None",
        "pride": "Pride / LGBTQ+",
        "trans": "Trans",
        "neurodivergent": "Neurodivergent",
        "hidden_disability": "Hidden disability",
        "accessibility": "Accessibility",
        "deaf_hoh": "Deaf / Hard of hearing",
        "service_animal": "Service animal",
        "mask_friendly": "Mask-friendly",
        "alcohol_free": "Alcohol-free",
        "alcohol_friendly": "Alcohol-friendly",
        "cannabis_friendly": "Cannabis-friendly",
        "no_smoking": "No smoking",
        "quiet_places": "Quiet places preferred",
        "low_sensory": "Low-sensory preferred",
        "small_groups": "Small groups preferred",
        "one_to_one": "One-to-one preferred",
        "text_first": "Text first",
        "new_to_area": "New to the area"
      }
    }
  },
  "vibeCard": {
    "entry": {
      "title": "Share your vibe",
      "subtitle": "Make a playful Opncue card with your avatar. No likes, no flexing — just your social energy today.",
      "button": "Create vibe card",
      "a11y": "Share your vibe"
    },
    "preview": {
      "shuffle": "Shuffle",
      "shuffleA11y": "Shuffle vibe card",
      "share": "Share",
      "shareA11y": "Share vibe card",
      "save": "Save",
      "saveA11y": "Save vibe card",
      "closeA11y": "Close vibe card preview",
      "includeName": "Include my display name",
      "editAvatar": "Edit avatar",
      "saved": "Vibe card saved",
      "error": "Couldn't create your vibe card. Please try again.",
      "cardA11y": "Vibe card preview"
    },
    "themes": {
      "navy": "Navy",
      "blue": "Blue",
      "light": "Light",
      "gradient": "Gradient"
    },
    "branding": {
      "madeWith": "made with Opncue"
    }
  },
  "monthlyVibeCard": {
    "entry": {
      "title": "Your monthly vibe card",
      "collectingTitle": "This month is still filling up",
      "collectingSubtitle": "Keep filling your Mood Jar. At month-end, Opncue will turn it into one gloriously questionable interpretation.",
      "collectingProgress": "Your Mood Jar is collecting clues for a questionably accurate month-end vibe.",
      "readyTitle": "Your {{month}} Vibe Card is ready",
      "readySubtitle": "Your Mood Jar is ready to be questionably interpreted.",
      "reveal": "Reveal my month",
      "compactReveal": "Reveal month",
      "availableTitle": "Your {{month}} Vibe Card",
      "availableSubtitle": "Weirdly wrong. Weirdly accurate.",
      "view": "View card",
      "insufficientTitle": "Not enough clues just yet",
      "insufficientSubtitle": "Give your Mood Jar a few more moments before Opncue starts jumping to conclusions",
      "dashboardInsufficientDescription": "At the end of the month, Opncue turns the moods into one questionably accurate card that keeps things light without making light of them.",
      "dashboardInsufficientDisclaimer": "Accuracy not guaranteed. A playful take is the point.",
      "addMoods": "Add to your Mood Jar",
      "expiredTitle": "That month has been put away",
      "expiredSubtitle": "Mood Jar entries are cleared once their card is made, so there's nothing left to read for this one. This month's jar is open though.",
      "unavailableTitle": "Nothing to reveal yet",
      "unavailableSubtitle": "There is no card for this month. Keep adding moments and check back once the month wraps up.",
      "unknownTitle": "We could not load this card",
      "unknownSubtitle": "Your Mood Jar is safe. Check your connection and try again."
    },
    "generator": {
      "title": "Revealing your month",
      "generating": "OpnCue is reaching an unnecessarily confident conclusion…",
      "error": "Something went wrong while reaching a conclusion.",
      "failedTitle": "No conclusion was reached",
      "failedSubtitle": "Your Mood Jar is safe. This card could not be completed."
    },
    "editor": {
      "share": "Share",
      "save": "Save",
      "close": "Close"
    },
    "branding": {
      "madeWith": "made with Opncue"
    },
    "verdict": {
      "label": "Monthly Vibe Verdict",
      "stamp": "Verdict"
    },
    "onePic": {
      "label": "My month, apparently"
    },
    "receipt": {
      "label": "Monthly Vibe Receipt",
      "item": "Item",
      "description": "Description",
      "status": "Status",
      "questionablyApproved": "Questionably approved",
      "accuracy": "Accuracy not guaranteed",
      "thanks": "thanks for being you"
    }
  },
  "moodJar": {
    "title": "Mood Jar",
    "subtitle": "Drop a mood into your jar anytime. At month-end, Opncue turns it all into one questionably accurate Vibe Card.",
    "addToJar": "Add to Mood Jar",
    "added": "Added to your Mood Jar",
    "intensity": {
      "heading": "How strongly?",
      "aLittle": "A little",
      "aBit": "A bit",
      "medium": "Medium",
      "strong": "Strong",
      "aLot": "A lot"
    },
    "intensityLow": "A little",
    "intensityHigh": "A lot",
    "submit": "Add to Mood Jar",
    "submitting": "Adding...",
    "success": "Added to your Mood Jar",
    "successGentle": "Added to your Mood Jar",
    "error": "Couldn’t add that right now. Try again.",
    "recentTitle": "Recently in your jar",
    "empty": "Your jar is empty this month. Add your first mood.",
    "remove": "Remove",
    "open": "Open Mood Jar",
    "a11yAddMood": "Add {{mood}} to your Mood Jar",
    "jar": {
      "emptySummary": "Your jar is ready for its first mood",
      "singleSummary": "1 mood in your jar this month",
      "countSummary": "{{count}} moods in your jar this month",
      "microcopy": "Tap to stir, or hold to gather and let go.",
      "a11yLabel": "Mood Jar, {{count}} moods collected this month.",
      "a11yHint": "Activate to stir the moods. Hold to gather them, then let go to scatter them.",
      "emptyHint": "Fill it through the month and Opncue reads it at month end.",
      "microcopyMotion": "Tap to stir · hold to gather · tilt to drift · shake for a storm."
    },
    "mood": {
      "heading": "How are you feeling?",
      "otherPlaceholder": "Name it in 20 characters",
      "showMore": "Show all moods",
      "showLess": "Show fewer moods"
    },
    "moods": {
      "calm": "Calm",
      "centered": "Centered",
      "content": "Content",
      "peaceful": "Peaceful",
      "relaxed": "Relaxed",
      "present": "Present",
      "happy": "Happy",
      "delighted": "Delighted",
      "excited": "Excited",
      "energized": "Energized",
      "inspired": "Inspired",
      "playful": "Playful",
      "refreshed": "Refreshed",
      "grateful": "Grateful",
      "hopeful": "Hopeful",
      "proud": "Proud",
      "confident": "Confident",
      "curious": "Curious",
      "connected": "Connected",
      "caring": "Caring",
      "vulnerable": "Vulnerable",
      "sad": "Sad",
      "lonely": "Lonely",
      "disappointed": "Disappointed",
      "grieving": "Grieving",
      "weary": "Weary",
      "anxious": "Anxious",
      "nervous": "Nervous",
      "worried": "Worried",
      "scared": "Scared",
      "overwhelmed": "Overwhelmed",
      "stressed": "Stressed",
      "burned_out": "Burned out",
      "frustrated": "Frustrated",
      "irritated": "Irritated",
      "angry": "Angry",
      "restless": "Restless",
      "confused": "Confused",
      "bored": "Bored",
      "numb": "Numb",
      "embarrassed": "Embarrassed",
      "guilty": "Guilty",
      "ashamed": "Ashamed",
      "meh": "Meh",
      "overthinking": "Overthinking",
      "other": "Other"
    },
    "context": {
      "heading": "What’s shaping this mood?",
      "optional": "Optional",
      "otherPlaceholder": "Name it in 25 characters"
    },
    "contexts": {
      "work": "Work",
      "people": "People",
      "home": "Home",
      "sleep": "Sleep",
      "health": "Health",
      "plans": "Plans",
      "weather": "Weather",
      "money": "Money",
      "one_of_those_days": "One of those days",
      "other": "Other"
    },
    "a11yMoodOption": "{{label}}, mood",
    "a11yContextOption": "{{label}}, optional mood context"
  }
}
